export const locale = {
  selectMarket: 'Select Market',
  searchSymbol: 'Search symbol'
};
